import React from "react";
import { PodcastTranscripts } from "src/types/coaching/podcast";

export interface PodcastContextProps {
  id?: string;

  startingPodcast?: boolean;
  enrollingPodcast?: boolean;

  transcripts?: PodcastTranscripts;

  from?: string;

  onBack?: () => void;
  startPodcast?: () => void;
  enrollPodcast?: () => void;

  // eslint-disable-next-line no-unused-vars
  onAnalyticsChange?: (event: any) => void;
}

export const PodcastContext = React.createContext<PodcastContextProps>({

});